import { GetMinimumWithdrawSettingResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMinimumWithdrawSetting } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetMinimumWithdraw(
	props?: UseBaseQueryOptions<GetMinimumWithdrawSettingResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetMinimumWithdrawSetting],
		queryFn: () => getMinimumWithdrawSetting(),
		...props,
	})
}
